module.exports = __webpack_public_path__ + "img/new_point1.907f6187.png";